import debounce from './debounce';

export const objectUnique = function objectUnique(obj, comp) {
  return obj
    .map((e) => e[comp])
    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)
    // eliminate the dead keys & store unique objects
    .filter((e) => obj[e]).map((e) => obj[e]);
};

export const autoScroll = function autoScroll(id) {
  // auto-scroll to form
  debounce(() => {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      link.setAttribute('href', id);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, 450)();
};

export default {
  objectUnique,
  autoScroll,
};
